export const AnvilActionTypes = {
    API_RESPONSE_SUCCESS: '@@anvil/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@anvil/API_RESPONSE_ERROR',
    REVIEW_PDF: '@@anvil/REVIEW_PDF',
    SIGN_ETCH_PACKET2: '@@anvil/SIGN_ETCH_PACKET2',
    RESET_ANVIL2: '@@anvil/RESET_ANVIL2',
};
